import * as FilterService from './filter.service'

export { FilterService }

const defaultConfig = {
  payload: {},
  tm: 2000,
  isReject: false,
  error: new Error('Fake Error')
}
export const fakeRequest = (config = {}) =>
  new Promise((resolve, reject) => {
    const c = { ...defaultConfig, ...config }
    setTimeout(() => {
      if (c.isReject) reject(c.error)
      else resolve(c.payload)
    }, c.tm)
  })
